import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import styled, { ThemeProvider } from "styled-components";
import {
	MarkdownNDRToggleState,
	UseNDRColors,
} from "../../state/accessibility";
import { CurrentFilter, FilterColors } from "../../state/filter";

import type { SDK_Colors } from "@quickpoint.me/shared";

const StyledNDRButton = styled.button<{
	$isChecked: boolean;
	$colors: SDK_Colors;
}>`
	background: ${(props) => props.$colors.third};
	color: ${(props) => props.$colors.first};
	border: 1px solid ${(props) => props.$colors.first};
	border-radius: 4px;
	padding: 2px 10px;
	margin-inline-start: .6rem;
	cursor: pointer;
	z-index: 10;
	pointer-events: auto;
`;

export default function NDRToggle() {
	const [isChecked, setIsChecked] = useRecoilState(MarkdownNDRToggleState);
	const setUseNDRColors = useSetRecoilState(UseNDRColors);
	const colors = useRecoilValue(FilterColors);
	const filter = useRecoilValue(CurrentFilter);

	const handleClick = (event: React.MouseEvent) => {
		event.stopPropagation();
		const newCheckedState = !isChecked;
		setIsChecked(newCheckedState);
		setUseNDRColors(newCheckedState);
	};

	return (
		<ThemeProvider theme={filter.button}>
			<StyledNDRButton
				type="button"
				onClick={handleClick}
				$isChecked={isChecked}
				$colors={colors}
			>
				{isChecked ? "On" : "Off"}
			</StyledNDRButton>
		</ThemeProvider>
	);
}
